
export enum msManagement {
  DiseaseModifyingTreatment = 'Disease modifying treatment',
  Exercise = 'Exercise',
  Diet = 'Diet',
  ImprovedLifestyle = 'Improved lifestyle',
}

export interface IMSImportantActivities {
  id: number;
  name: msManagement,
  rank?: number;
}

const MSImportantActivities: IMSImportantActivities[] = [
  { id: 1, name: msManagement.DiseaseModifyingTreatment, },
  { id: 2, name: msManagement.Exercise,  },
  { id: 3, name: msManagement.Diet, },
  { id: 4, name: msManagement.ImprovedLifestyle },
]

export default MSImportantActivities;